import axios from 'axios';

export default axios.create({
  // baseURL: 'https://api.language-interpreters.com/prod',
  baseURL: process.env.REACT_APP_BASE_URL,
  responseType: 'json',
});
